import ResizeGroupExample from "./examples/ResizeGroup.Example";

export default [
    {
        title: " Resize Group Example",
        component: ResizeGroupExample,
        code: require("!raw-loader!./examples/ResizeGroup.Example.tsx")
    }
];
